module.exports = __webpack_public_path__ + "img/sxwd2.8edbd113.svg";